import { connect, h, mapProps, mapReadPretty } from '@formily/vue'
import { defineComponent } from 'vue-demi'
import { SelectPreviewText } from '../PreviewText'
import RadioView from './RadioView.vue'
import './style.scss'

const RadioGroupBase = defineComponent({
  name: 'RadioGroup',
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { attrs, slots, listeners }) {
    return () => {
      const { options = [] } = props
      return h(
        RadioView,
        {
          props: { options },
          attrs: {
            ...attrs
          },
          on: listeners
        },
        []
      )
    }
  }
})

const Radio = connect(
  RadioGroupBase,
  mapProps({ dataSource: 'options' }),
  mapReadPretty(SelectPreviewText)
)

export {
  RadioView
}

export default Radio
